import React, {useState} from 'react'
import emailjs from "emailjs-com";
import axios from "axios"; 

const Contact = () => {

    const [serverState, setServerState] = useState({
      submitting: false,
      status: null
    });
    const handleServerResponse = (ok, msg, form) => {
      setServerState({
        submitting: false,
        status: { ok, msg }
      });
      if (ok) {
        form.reset();
      }
    };
    const handleOnSubmit = e => {
      e.preventDefault();
      const form = e.target;
      setServerState({ submitting: true });
      axios({
        method: "post",
        url: "https://getform.io/f/a1a2f421-4f86-41d2-a333-96c32948497e",
        data: new FormData(form)
      })
        .then(r => {
          handleServerResponse(true, "Thanks!", form);
        })
        .catch(r => {
          handleServerResponse(false, r.response.data.error, form);
        });
    };

    return <section className="contact-page" id="contact">
        <article className="contact-form">
            <h3>get in touch</h3>
            <form onSubmit={handleOnSubmit}>
                <div className="form-group">
                    <input type="text" name="name" placeholder="name" className="form-control"/>
                    <input type="email" name="email" placeholder="email" className="form-control"/>
                    <textarea name="message" rows="5" placeholder="message" className="form-control"></textarea>
                </div>
                <button type="submit" className="submit-btn btn">submit here</button>
                {serverState.status && (
                <p className={!serverState.status.ok ? "errorMsg" : ""}>
                {serverState.status.msg}
                </p>
            )}
            </form>
        </article>
    </section>
}

export default Contact
